export default [
  {
    title: 'Dashboards',
    route: 'my-poda-dashboard',
    tabIcon: '/svg/tab/Dashboards.svg',
    tabIconActive: '/svg/tab/DashboardsWhite.svg',
  },
]
